var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramMoneyOut64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Moneyout64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dollar",
    transform: "translate(25.000000, 22.000000)",
    stroke: "#4F4D4C",
    strokeWidth: 2.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,20.3125 L6.00313032,20.3125 M5.25,12.5 L3.75,12.5 M2.99686968,4.6875 L9,4.6875",
    id: "Arms"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75,4.6875 C1.67893219,4.6875 0,6.4363877 0,8.59375 C0,10.7511123 1.67893219,12.5 3.75,12.5 L3.75,12.5",
    id: "Curve"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,12.5 C6.92893219,12.5 5.25,14.2488877 5.25,16.40625 C5.25,18.5636123 6.92893219,20.3125 9,20.3125",
    id: "Curve-bottom",
    transform: "translate(7.125000, 16.406250) scale(-1, 1) translate(-7.125000, -16.406250) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 4.6875,
    x2: 4.5,
    y2: 0,
    id: "Stick-top"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 25,
    x2: 4.5,
    y2: 20.3125,
    id: "Stick-bottom"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Swoop",
    transform: "translate(5.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9242175,1.92982456 L23.9242175,4.56140351 C12.1579137,4.56140351 2.61943987,14.1440808 2.61943987,25.9649123 C2.61943987,37.7857438 12.1579137,47.3684211 23.9242175,47.3684211 C35.4525831,47.3684211 44.8586599,38.1630865 45.2183234,26.6492174 L45.2273716,26.2320602 L45.2289951,3.24561404 L47.8484349,3.24561404 L47.8466161,26.264206 C47.6867345,39.4123951 37.0260947,50 23.9242175,50 C10.711237,50 0,39.2391247 0,25.9649123 C0,12.8381911 10.4745319,2.16926541 23.4847226,1.93379876 L23.9242175,1.92982456 Z",
    id: "Path",
    fill: "#4F4C4D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "End",
    stroke: "#4F4C4D",
    strokeWidth: 2.65,
    fill: "#FFCC00",
    transform: "translate(46.538715, 4.868421) scale(1, -1) rotate(-270.000000) translate(-46.538715, -4.868421) ",
    points: "51.407136 4.86842105 41.6702939 11.3297061 41.6702939 -1.59286396"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramMoneyOut64);
export default __webpack_public_path__ + "static/media/pictogramMoneyOut64.0d57e06acae2a96f536a6413754a1032.svg";
export { ForwardRef as ReactComponent };